import { useCallback, useEffect, useRef, useState } from "react";
import { useModalResize } from "./ModalWrapperContent";

interface ModalWrapperProps {
	children: React.ReactNode;
	size?: string;                              // string으로 유연하게 설정
	width?: number;                             // width는 선택적 (기본값 70)
	overlay?: boolean;
	zIndex?: number;
	onOverlayClick?: () => void;
	onEscKeyDown?: () => void;
}

const ModalWrapper = ({ 
	children, 
	size = 'lg', 
	width = 800, 
	overlay = false, 
	zIndex = 10,
	onOverlayClick, 
	onEscKeyDown,
}: ModalWrapperProps) => {
	
	// size에 따른 height 자동 설정
	const getHeightBySize = (size: string) => {
		const heightMap: Record<string, number> = {
			hxs: 20,
			qxs: 25,
			xs: 30,
			hsm: 40,
			qsm: 45,
			sm: 50,
			qhmd: 55,
			hmd: 60,
			qmd: 65,
			md: 70,
			lg: 80,
			xl: 90,
			half: 50,    // 기존 값 추가
		};
		return heightMap[size] || 50;
	};

	const height = getHeightBySize(size);
	const modalRef = useRef<HTMLDivElement>(null);
	const { handleResizeMouseDown } = useModalResize(modalRef);

	const handleEscKeyDown = useCallback((e: KeyboardEvent) => {
		// event.ctrlKey가 true이고 (Ctrl 키가 눌린 상태)
		// event.key가 'Escape'이면 (Escape 키가 눌렸을 때)
		if (e.key === 'Escape' && onEscKeyDown) {
			onEscKeyDown()
		}
	}, []); // useCallback으로 함수를 메모이제이션합니다.
	
	useEffect(() => {
		// 이벤트 리스너 추가
		window.addEventListener('keydown', handleEscKeyDown);
		// cleanup 함수에서 리스너 제거
		return () => {
			window.removeEventListener('keydown', handleEscKeyDown);
		};
	}, [])


	return (
		<div className="fixed inset-0 flex justify-center items-center" style={{ zIndex }}>
			{overlay && <div className="w-full h-full absolute bg-black opacity-[0]" onClick={onOverlayClick} />}
			<div 
				ref={modalRef}
				className="relative flex flex-col bg-white shadow-xl rounded-[8px] z-10 border-2 border-black"
				style={{ 
					width: `${width}px`,
					height: `${height}%`,
					maxHeight: `${height}%`
				}}
			>
				<div className="flex-1 w-full h-full overflow-auto">
					{children}
				</div>
				<div
					className="absolute bottom-1 right-0.5 w-4 h-4 cursor-nwse-resize z-50 flex items-end justify-end p-0.5"
					onMouseDown={handleResizeMouseDown}
				>
					<div className="w-full h-full border-r-2 border-b-2 border-gray-400"></div>
				</div>
			</div>
		</div>
	);
};

export default ModalWrapper;
